// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables = Types.Exact<{
  structureId: Types.Scalars['ID']['input'];
}>;


export type ApplicableProductOfferingConfigsPageStructureMetadataQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string, name: string } } }, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?: { __typename?: 'ReadyPlan' } | { __typename?: 'PlanPackage' } | { __typename?: 'DesignPackage' } | { __typename?: 'ProductOffering', id: string, name: string, planPackage: { __typename?: 'PlanPackage', id: string, name: string } } | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }, changeEventReasons: Array<{ __typename?: 'ChangeEventReason', id: string, code: string }> };

export type ApplicableProductOfferingConfigsPage_StructureFragment = { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string, name: string } } }, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?: { __typename?: 'ReadyPlan' } | { __typename?: 'PlanPackage' } | { __typename?: 'DesignPackage' } | { __typename?: 'ProductOffering', id: string, name: string, planPackage: { __typename?: 'PlanPackage', id: string, name: string } } | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type AppliableProductOfferingConfigsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProductOfferingConfigsFilter>;
  order?: Types.InputMaybe<Types.ProductOfferingConfigOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
  structureId: Types.Scalars['ID']['input'];
}>;


export type AppliableProductOfferingConfigsQuery = { __typename?: 'Query', productOfferingConfigs: { __typename?: 'ProductOfferingConfigsPage', entities: Array<{ __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], createdBy: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined }, productOffering: { __typename?: 'ProductOffering', id: string, name: string, planPackage: { __typename?: 'PlanPackage', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } }, checkoutConfigs: { __typename?: 'CheckoutConfigsPage', entities: Array<{ __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], isReversed: boolean, status: Types.CheckoutConfigStatus, createdBy?: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } | null | undefined }> } };

export type AppliableProductOfferingConfigs_ProductOfferingConfigFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], createdBy: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined }, productOffering: { __typename?: 'ProductOffering', id: string, name: string, planPackage: { __typename?: 'PlanPackage', id: string, name: string } } };

export type AppliableProductOfferingConfigs_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], isReversed: boolean, status: Types.CheckoutConfigStatus, createdBy?: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } | null | undefined };

export type AppliableProductOfferingConfigs_UserFragment = { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined };

export type AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventInput;
}>;


export type AppliableProductOfferingConfigsApplyWithoutChangesMutation = { __typename?: 'Mutation', saveChangeEvent: { __typename?: 'SaveChangeEventResult', changeEvent: { __typename?: 'ChangeEvent', id: string } } };

export const ApplicableProductOfferingConfigsPage_StructureFragmentDoc = gql`
    fragment ApplicableProductOfferingConfigsPage_Structure on Structure {
  ...Named
  parent {
    ...Named
    parent {
      ...Named
      parent {
        ...Named
      }
    }
  }
  readyPlanConfig {
    id
    readyPlan {
      ... on ProductOffering {
        id
        name
        planPackage {
          ...Named
        }
      }
    }
    createdAt
    updatedAt
    orientation
    readyPlanOptions {
      id
    }
  }
  stages {
    id
    hasSignedContract
    stage {
      code
    }
  }
}
    ${NamedFragmentDoc}`;
export const AppliableProductOfferingConfigs_UserFragmentDoc = gql`
    fragment AppliableProductOfferingConfigs_User on User {
  id
  internalUser {
    ...Named
    avatar
  }
}
    ${NamedFragmentDoc}`;
export const AppliableProductOfferingConfigs_ProductOfferingConfigFragmentDoc = gql`
    fragment AppliableProductOfferingConfigs_ProductOfferingConfig on ProductOfferingConfig {
  id
  name
  updatedAt
  createdAt
  createdBy {
    ...AppliableProductOfferingConfigs_User
  }
  productOffering {
    ...Named
    planPackage {
      ...Named
    }
  }
}
    ${AppliableProductOfferingConfigs_UserFragmentDoc}
${NamedFragmentDoc}`;
export const AppliableProductOfferingConfigs_CheckoutConfigFragmentDoc = gql`
    fragment AppliableProductOfferingConfigs_CheckoutConfig on CheckoutConfig {
  id
  name
  createdAt
  updatedAt
  createdBy {
    ...AppliableProductOfferingConfigs_User
  }
  isReversed
  status
  productOffering {
    ...Named
  }
  aggregateVersion {
    id
    displayName
  }
}
    ${AppliableProductOfferingConfigs_UserFragmentDoc}
${NamedFragmentDoc}`;
export const ApplicableProductOfferingConfigsPageStructureMetadataDocument = gql`
    query ApplicableProductOfferingConfigsPageStructureMetadata($structureId: ID!) {
  structure(id: $structureId) {
    ...ApplicableProductOfferingConfigsPage_Structure
  }
  changeEventReasons {
    id
    code
  }
}
    ${ApplicableProductOfferingConfigsPage_StructureFragmentDoc}`;

/**
 * __useApplicableProductOfferingConfigsPageStructureMetadataQuery__
 *
 * To run a query within a React component, call `useApplicableProductOfferingConfigsPageStructureMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicableProductOfferingConfigsPageStructureMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicableProductOfferingConfigsPageStructureMetadataQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useApplicableProductOfferingConfigsPageStructureMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables> & ({ variables: ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables>(ApplicableProductOfferingConfigsPageStructureMetadataDocument, options);
      }
export function useApplicableProductOfferingConfigsPageStructureMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables>(ApplicableProductOfferingConfigsPageStructureMetadataDocument, options);
        }
export function useApplicableProductOfferingConfigsPageStructureMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables>(ApplicableProductOfferingConfigsPageStructureMetadataDocument, options);
        }
export type ApplicableProductOfferingConfigsPageStructureMetadataQueryHookResult = ReturnType<typeof useApplicableProductOfferingConfigsPageStructureMetadataQuery>;
export type ApplicableProductOfferingConfigsPageStructureMetadataLazyQueryHookResult = ReturnType<typeof useApplicableProductOfferingConfigsPageStructureMetadataLazyQuery>;
export type ApplicableProductOfferingConfigsPageStructureMetadataSuspenseQueryHookResult = ReturnType<typeof useApplicableProductOfferingConfigsPageStructureMetadataSuspenseQuery>;
export type ApplicableProductOfferingConfigsPageStructureMetadataQueryResult = Apollo.QueryResult<ApplicableProductOfferingConfigsPageStructureMetadataQuery, ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables>;
export const AppliableProductOfferingConfigsDocument = gql`
    query AppliableProductOfferingConfigs($filter: ProductOfferingConfigsFilter, $order: ProductOfferingConfigOrder, $page: PageFilter, $structureId: ID!) {
  productOfferingConfigs(filter: $filter, order: $order, page: $page) {
    entities {
      ...AppliableProductOfferingConfigs_ProductOfferingConfig
    }
    pageInfo {
      totalCount
    }
  }
  checkoutConfigs(filter: {structure: [$structureId]}) {
    entities {
      ...AppliableProductOfferingConfigs_CheckoutConfig
    }
  }
}
    ${AppliableProductOfferingConfigs_ProductOfferingConfigFragmentDoc}
${AppliableProductOfferingConfigs_CheckoutConfigFragmentDoc}`;

/**
 * __useAppliableProductOfferingConfigsQuery__
 *
 * To run a query within a React component, call `useAppliableProductOfferingConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppliableProductOfferingConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppliableProductOfferingConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAppliableProductOfferingConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables> & ({ variables: AppliableProductOfferingConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables>(AppliableProductOfferingConfigsDocument, options);
      }
export function useAppliableProductOfferingConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables>(AppliableProductOfferingConfigsDocument, options);
        }
export function useAppliableProductOfferingConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables>(AppliableProductOfferingConfigsDocument, options);
        }
export type AppliableProductOfferingConfigsQueryHookResult = ReturnType<typeof useAppliableProductOfferingConfigsQuery>;
export type AppliableProductOfferingConfigsLazyQueryHookResult = ReturnType<typeof useAppliableProductOfferingConfigsLazyQuery>;
export type AppliableProductOfferingConfigsSuspenseQueryHookResult = ReturnType<typeof useAppliableProductOfferingConfigsSuspenseQuery>;
export type AppliableProductOfferingConfigsQueryResult = Apollo.QueryResult<AppliableProductOfferingConfigsQuery, AppliableProductOfferingConfigsQueryVariables>;
export const AppliableProductOfferingConfigsApplyWithoutChangesDocument = gql`
    mutation AppliableProductOfferingConfigsApplyWithoutChanges($input: SaveChangeEventInput!) {
  saveChangeEvent(input: $input) {
    changeEvent {
      id
    }
  }
}
    `;
export type AppliableProductOfferingConfigsApplyWithoutChangesMutationFn = Apollo.MutationFunction<AppliableProductOfferingConfigsApplyWithoutChangesMutation, AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables>;

/**
 * __useAppliableProductOfferingConfigsApplyWithoutChangesMutation__
 *
 * To run a mutation, you first call `useAppliableProductOfferingConfigsApplyWithoutChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppliableProductOfferingConfigsApplyWithoutChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appliableProductOfferingConfigsApplyWithoutChangesMutation, { data, loading, error }] = useAppliableProductOfferingConfigsApplyWithoutChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppliableProductOfferingConfigsApplyWithoutChangesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AppliableProductOfferingConfigsApplyWithoutChangesMutation, AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AppliableProductOfferingConfigsApplyWithoutChangesMutation, AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables>(AppliableProductOfferingConfigsApplyWithoutChangesDocument, options);
      }
export type AppliableProductOfferingConfigsApplyWithoutChangesMutationHookResult = ReturnType<typeof useAppliableProductOfferingConfigsApplyWithoutChangesMutation>;
export type AppliableProductOfferingConfigsApplyWithoutChangesMutationResult = Apollo.MutationResult<AppliableProductOfferingConfigsApplyWithoutChangesMutation>;
export type AppliableProductOfferingConfigsApplyWithoutChangesMutationOptions = Apollo.BaseMutationOptions<AppliableProductOfferingConfigsApplyWithoutChangesMutation, AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables>;